module.exports = __webpack_public_path__ + "img/2012-08-18 09.17.57.cb907a69.jpg";